import { Injectable, Injector } from '@angular/core';
import { API_NAMES, ApiServiceBase } from '../api';
import { HttpClient } from '@angular/common/http';
import { ICheckOutInSettings } from '~/models/administration/checkOutInSettings';

@Injectable({
  providedIn: 'root'
})
export class CheckOutInSettingsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminAssets);
   }
   getCheckOutInSettings() {
    return this.http.get<ICheckOutInSettings>(this._url());
}

updateCheckOutInSettings(model: any) {
    return this.client.put(this._url(), model);
}

private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/CheckOutInSettings${v}`);
}

}
